import featuresAndBugsTour from "./features-bugs";
import homepageTour from "./homepage";

const driver_tour = {
	close: "Weet u zeker dat je de tour wilt afsluiten?",
	done: "Afsluiten",
	features_and_bugs_tour: featuresAndBugsTour,
	homepage_tour: homepageTour,
	next: "Volgende",
	previous: "Vorige",
	title: "Driver Tour",
};

export default driver_tour;
